/**
 * Created by linuxr on 2019/10/16.
 */
import UniScrollList from './UniScrollList.vue'
export default UniScrollList



// WEBPACK FOOTER //
// ./src/components/uniWidgets/uniScrollList/index.js